import * as v from "valibot";
import { rpcContract } from "../rpc";

export const adminUpdateFanRpcContract = rpcContract({
  name: "adminUpdateFan",
  paramsSchema: v.object({
    userId: v.string(),
    handle: v.optional(
      v.pipe(
        v.string(),
        v.minLength(3, "contract Handle must be at least 3 characters"),
        v.maxLength(64, "Handle must be at most 64 characters"),
        v.regex(
          /^[a-z0-9_\-.]+$/,
          "Handle can only contain lowercase letters, numbers, underscores, dots, and hyphens",
        ),
      ),
    ),
    email: v.pipe(v.string(), v.email("Please enter a valid email address")),
    isActive: v.boolean(),
    isStaff: v.boolean(),
  }),
  resultSchema: v.undefined(),
});

export type AdminUpdateFanParams = v.InferOutput<(typeof adminUpdateFanRpcContract)["paramsSchema"]>;
export type AdminUpdateFanResult = v.InferOutput<(typeof adminUpdateFanRpcContract)["resultSchema"]>;
